export default __webpack_public_path__ + "static/premioCCL-60a6c90da16aaa1d03716a708fb2f436.png";